import {
  EXCHANGE_CODE,
  EXCHANGE_CODE_SUCCESS,
  EXCHANGE_CODE_FAILED
} from "./actionTypes"

const initialState = {
  success: null,
  errorDetails: null,
  loading: false,
}

const oauthCallbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXCHANGE_CODE:
      state = {
        ...state,
        loading: true,
        success: null,
        errorDetails: null
      }
      break
    case EXCHANGE_CODE_SUCCESS:
      state = {
        ...state,
        loading: false,
        success: action.payload,
        errorDetails: null
      }
      break
    case EXCHANGE_CODE_FAILED:
      state = {
        ...state,
        loading: false,
        success: null,
        errorDetails: action.payload
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default oauthCallbackReducer
